import ApiBaseURL from "../../utils/config";
import ApiList from "../../utils/apiList";
import { GetUserAccessToken } from "../../utils/helper";

export const LoginUser = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.login, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const LoginUserFromThirdParty = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.ThirdPartyLogin, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const SendOTPRegister = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.register + "/GenerateOTP",
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};
export const ChangePassword = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.register + "/ChangePassword",
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const VerifyOTPResponse = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.register + "/VerifyOTP",
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const RegisterUser = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.register + "/Register",
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const ForgotPassword = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiForgotPassword,
    formData,
    {
      headers: {
        // Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const VerifyOTP = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiVerifyForgotPasswordOTP,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const RecoverPassword = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiRecoverPassword,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

